module.exports = __webpack_public_path__ + "img/add-dep.9ac12593.svg";